(function () {
  'use strict';

  if (window.JMTFirstCustomerTracking && window.JMTFirstCustomerTracking.initialized) return;

  var STORAGE = {
    lastSource: 'jmt:first-customer:last-source',
    sessionAttribution: 'jmt:first-customer:session-attribution-v2'
  };

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, String(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function publishToShopify(eventName, payload, attemptsLeft) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
        return;
      }
    } catch (error) {}

    if (attemptsLeft > 0) {
      window.setTimeout(function () {
        publishToShopify(eventName, payload, attemptsLeft - 1);
      }, 250);
    }
  }

  function publish(eventName, data) {
    var payload = Object.assign(
      {
        page_path: window.location.pathname || '/',
        page_url: window.location.href,
        occurred_at: new Date().toISOString()
      },
      data || {}
    );

    publishToShopify(eventName, payload, 20);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName.replace(/:/g, '_') }, payload));

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName.replace(/:/g, '_'), payload);
      }
    } catch (error) {}

    try {
      document.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    } catch (error) {}

    return payload;
  }

  function trackingSource() {
    var params = new URLSearchParams(window.location.search || '');
    return (
      params.get('jmt_source') ||
      storageGet(window.sessionStorage, STORAGE.lastSource) ||
      'direct'
    ).slice(0, 64);
  }

  function compactSource(source) {
    var sourceCodes = {
      homepage_bar: 'home',
      collection_bar: 'collection',
      product_bar: 'product',
      direct: 'direct'
    };
    return sourceCodes[source] || String(source || 'direct').replace(/_bar$/, '').slice(0, 32);
  }

  function updateCartAttribution(source) {
    if (storageGet(window.sessionStorage, STORAGE.sessionAttribution) === source) return;

    tracking.debug.cartAttribution = 'pending';

    function save(attempt) {
      if (!window.JMTOrderAttribution || typeof window.JMTOrderAttribution.set !== 'function') {
        if (attempt < 20) {
          window.setTimeout(function () { save(attempt + 1); }, 100);
        } else {
          tracking.debug.cartAttribution = 'failed';
        }
        return;
      }

      window.JMTOrderAttribution.set('NC', compactSource(source), { clearLegacy: true })
        .then(function () {
          storageSet(window.sessionStorage, STORAGE.sessionAttribution, source);
          tracking.debug.cartAttribution = 'saved';
        })
        .catch(function () {
          tracking.debug.cartAttribution = 'failed';
        });
    }

    save(0);
  }

  function markGuideVisit(marker) {
    var source = trackingSource();
    storageSet(window.sessionStorage, STORAGE.lastSource, source);

    tracking.debug.guidePage = true;
    tracking.debug.source = source;
    tracking.debug.pageViewPublished = true;

    publish('jmt:first_customer_page_view', {
      source: source,
      page_title: document.title,
      section_id: marker && marker.dataset.sectionId ? marker.dataset.sectionId : ''
    });
    updateCartAttribution(source);
  }

  var tracking = {
    initialized: true,
    publish: publish,
    debug: {
      guidePage: false,
      pageViewPublished: false,
      cartAttribution: 'not-requested',
      source: ''
    }
  };
  window.JMTFirstCustomerTracking = tracking;

  class JmtFirstCustomerBar extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.link = this.querySelector('[data-jmt-first-customer-link]');
      this.source = (this.dataset.trackingSource || 'storefront_bar').slice(0, 64);
      this.designMode = this.dataset.designMode === 'true';

      this.onLinkClick = this.handleLinkClick.bind(this);
      if (this.link) this.link.addEventListener('click', this.onLinkClick);
      this.show();
    }

    disconnectedCallback() {
      if (this.link) this.link.removeEventListener('click', this.onLinkClick);
      if (this.observer) this.observer.disconnect();
      this.initialized = false;
    }

    show() {
      this.hidden = false;
      this.removeAttribute('aria-hidden');
      tracking.debug.barVisible = true;
      tracking.debug.barSource = this.source;

      if ('IntersectionObserver' in window && !this.designMode) {
        this.observer = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
            this.recordImpression();
            this.observer.disconnect();
          }.bind(this),
          { threshold: 0.35 }
        );
        this.observer.observe(this);
      } else if (!this.designMode) {
        this.recordImpression();
      }
    }

    recordImpression() {
      if (this.impressionRecorded) return;
      this.impressionRecorded = true;
      publish('jmt:first_customer_bar_impression', {
        source: this.source,
        section_id: this.dataset.sectionId || ''
      });
    }

    handleLinkClick() {
      storageSet(window.sessionStorage, STORAGE.lastSource, this.source);
      publish('jmt:first_customer_bar_click', {
        source: this.source,
        section_id: this.dataset.sectionId || '',
        destination: this.link ? this.link.href : ''
      });
    }

  }

  if (!customElements.get('jmt-first-customer-bar')) {
    customElements.define('jmt-first-customer-bar', JmtFirstCustomerBar);
  }

  function initializeGuidePage() {
    var marker = document.querySelector('[data-jmt-first-customer-page]');
    if (marker) markGuideVisit(marker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGuidePage, { once: true });
  } else {
    initializeGuidePage();
  }
})();
